import * as users from "@/services/users";
import parseJwt from "@/util/parseJwt";
import { delCookie, getCookie } from "@/util/cookies";

const user = {
  namespaced: true,
  state: () => ({
    users: [],
    userInfo: {},
    assigneds: [],
    reviewers: [],
    forgotPassUsers: [],
    isLoadingInfo: false,
    isLoadingAvatar: false,
    maxPage: 1,
    totalResult: "",
    currentPage: 1,
    rowsPerPage: 10
  }),
  getters: {
    userAssigneds(state) {
      return state.assigneds.map(item => ({
        label: `${item.userName} (${item.userRoleName})`,
        value: item.userId
      }));
    },
    userReviewers(state) {
      return state.reviewers.map(item => ({
        label: `${item.userName} (${item.userRoleName})`,
        value: item.userId
      }));
    },
    members(state) {
      return state.users
        .filter(item => item.userPrivId === 3)
        .map(item => {
          return {
            label:
              item.userName.charAt(0).toUpperCase() + item.userName.slice(1),
            value: item.userId
          };
        });
    },
    managers(state) {
      return state.users
        .filter(item => item.userPrivId === 2)
        .map(item => {
          return {
            label:
              item.userName.charAt(0).toUpperCase() + item.userName.slice(1),
            value: item.userId
          };
        });
    },
    teamLeaders(state) {
      return state.users
        .filter(item => item.userPrivId === 4)
        .map(item => {
          return {
            label:
              item.userName.charAt(0).toUpperCase() + item.userName.slice(1),
            value: item.userId
          };
        });
    },
    exceptAdminUser(state) {
      return state.users.filter(item => item.userId !== 1);
    },
    adminUser(state) {
      return state.users
        .map(item => (
          {
            label: item.userName,
            value: item.userId
          }))
        .filter(item => item.value === 1);
    },
    allUsers(state) {
      return state.users.map(item => {
        return {
          label: item.userName.charAt(0).toUpperCase() + item.userName.slice(1),
          value: item.userId,
        };
      });
    }
  },
  mutations: {
    setUsers(state, response) {
      state.users = response.data;
      state.maxPage = response.maxPage;
      state.totalResult = response.totalResult;
    },
    setForgotPassUsers(state, response) {
      state.forgotPassUsers = response.data;
      state.maxPage = response.maxPage;
      state.totalResult = response.totalResult;
    },
    setCurrentPage(state, params) {
      state.currentPage = params;
    },
    setAssigneds(state, response) {
      state.assigneds = response.data;
    },
    setReviewers(state, response) {
      state.reviewers = response.data;
    },
    setRowsPerPage(state, params) {
      state.rowsPerPage = params;
    },
    setUserInfo(state, params) {
      state.userInfo = params;
    }
  },
  actions: {
    async callGetAllUsers(store, request = {}) {
      try {
        const response = await users.index(request);
        store.commit("setUsers", response.data);
      } catch (err) {
        console.log(err);
      }
    },
    async callAllUsers(store, request = {}) {
      try {
        const response = await users.indexUsers(request);
        store.commit("setUsers", response.data);
      } catch (err) {
        console.log(err);
      }
    },
    async callCreateUser(store, request) {
      try {
        await users.create(request);
        store.commit("setCurrentPage", 1);
        store.commit("setRowsPerPage", 10);
        return await store.dispatch("callGetAllUsers", { page: 1, row: 10 });
      } catch (err) {
        throw err;
      }
    },
    async callDeleteUser(store, request) {
      try {
        await users.destroy(request);
        store.commit("setCurrentPage", 1);
        store.commit("setRowsPerPage", 10);
        return await store.dispatch("callGetAllUsers", { page: 1, row: 10 });
      } catch (err) {
        throw err;
      }
    },
    async callDeleteUserBatch(store, request) {
      try {
        await users.deleteBatch(request);
        store.commit("setCurrentPage", 1);
        store.commit("setRowsPerPage", 10);
        return await store.dispatch("callGetAllUsers", { page: 1, row: 10 });
      } catch (err) {
        throw err;
      }
    },
    async callUpdateUser(store, request) {
      try {
        let newRequest = new FormData();
        newRequest.append("userId", request.userId);
        newRequest.append("fullname", request.fullname);
        newRequest.append("email", request.email);
        newRequest.append("phone", request.phone);
        newRequest.append("gender", request.gender);
        newRequest.append("divisionId", request.divisionId);
        newRequest.append("newPassword", request.newPassword);
        await users.update(newRequest);
        store.commit("setCurrentPage", 1);
        store.commit("setRowsPerPage", 10);
        return await store.dispatch("callGetAllUsers", { page: 1, row: 10 });
      } catch (err) {
        throw err;
      }
    },
    async callListForgotPassUser(store, request) {
      try {
        const response = await users.indexChangePass(request);
        store.commit("setForgotPassUsers", response.data);
      } catch (err) {
        throw err;
      }
    },
    async changePasswordUser(store, request) {
      try {
        let newRequest = new FormData();
        newRequest.append("userId", request.userId);
        newRequest.append("newPassword", request.newPassword);
        await users.update(newRequest);
        store.commit("setCurrentPage", 1);
        store.commit("setRowsPerPage", 10);
        return await store.dispatch("callListForgotPassUser", {
          page: 1,
          row: 10
        });
      } catch (err) {
        throw err;
      }
    },
    async changePasswordAdmin(store, request) {
      try {
        let newRequest = new FormData();
        newRequest.append("userId", request.userId);
        newRequest.append("fullname", request.fullname);
        newRequest.append("email", request.email);
        newRequest.append("newPassword", request.newPassword);
        newRequest.append("oldPassword", request.oldPassword);
        await users.update(newRequest);
        return await store.dispatch("callGetAllUsers", {
          userId: request.userId
        });
      } catch (err) {
        throw err;
      }
    },
    async changeAvatar(store, request) {
      try {
        store.state.isLoadingAvatar = true;
        let newRequest = new FormData();
        newRequest.append("userId", request.userId);
        newRequest.append("file", request.photo);
        await users.update(newRequest);
        setTimeout(async () => {
          await store.dispatch("callUserInfo");
          return (store.state.isLoadingAvatar = false);
        }, 2000);
      } catch (err) {
        store.state.isLoadingAvatar = false;
        throw err;
      }
    },
    async changePasswordManager(store, request) {
      try {
        let newRequest = new FormData();
        newRequest.append("userId", request.userId);
        newRequest.append("fullname", request.fullname);
        newRequest.append("gender", request.gender);
        newRequest.append("email", request.email);
        newRequest.append("phone", request.phone);
        newRequest.append("newPassword", request.newPassword);
        newRequest.append("oldPassword", request.oldPassword);
        await users.update(newRequest);
        return await store.dispatch("callUserInfo");
      } catch (err) {
        throw err;
      }
    },
    async callRemoveAvatar(store, request) {
      try {
        await users.destroyAvatar(request);
      } catch (err) {
        throw err;
      }
    },
    async callForgotPass(store, request) {
      try {
        await users.createForgotPass(request);
      } catch (err) {
        throw err;
      }
    },
    async callUserInfo(store) {
      try {
        store.state.isLoadingInfo = true;
        const token = getCookie("token");
        if (token) {
          const { userId } = parseJwt(token);
          const response = await users.index({ page: 0, row: 10, userId });
          store.commit("setUserInfo", response.data.data[0]);
          store.state.isLoadingInfo = false;
        }
      } catch (err) {
        throw err;
      }
    },
    async logoutUser() {
      try {
        await users.logout();
        delCookie('token')
      } catch (err) {
        throw err;
      }
    },
    async callUserAssigned(store, request) {
      try {
        const response = await users.indexAssigned(request);
        store.commit("setAssigneds", response.data);
      } catch (err) {
        throw err;
      }
    },
    async callUserReviewer(store, request) {
      try {
        const response = await users.indexReviewer(request);
        store.commit("setReviewers", response.data);
      } catch (err) {
        throw err;
      }
    },
    async callToExcel(store, request) {
      try {
        return await users.indexExcel(request);
      } catch (err) {
        throw err;
      }
    }
  }
};

export default user;
